import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=fc9df05c&scoped=true&"
import script from "./ContactInfo.vue?vue&type=script&lang=js&"
export * from "./ContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9df05c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc9df05c')) {
      api.createRecord('fc9df05c', component.options)
    } else {
      api.reload('fc9df05c', component.options)
    }
    module.hot.accept("./ContactInfo.vue?vue&type=template&id=fc9df05c&scoped=true&", function () {
      api.rerender('fc9df05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/ContactInfo.vue"
export default component.exports